import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { img } from "../../constants/assets";
import ScrollReveal from "../../components/ScrollReveal";
import GlobalConnected from "../../components/GlobalConnected";
import PlatformArchitecture from "../../components/PlatformArchitecture";
import PlatformPillars from "../../components/PlatformPillars";
import ReadyToBuild from "../../components/ReadyToBuild";

const integrateIcons = ["api-icon.svg", "real-time.svg", "sanbox.svg", "webhook.svg"];
const technologyIcons = ["tech1.svg", "tech2.svg", "tech3.svg", "tech4.svg"];

function Technology() {
  const { t } = useTranslation();
  const integrateFeatures = t("technology.integrateFeatures", { returnObjects: true });
  const technologyResults = t("technology.technologyResults", { returnObjects: true });

  return (
    <>
      <section
        className="industries-hero technology"
        style={{ "--hero-bg-image": `url(${img("technology-bg.svg")})` }}
      >
        <div className="container py-2">
          <div className="row align-items-center g-4 g-lg-5">
            <div className="col-md-6 d-flex hero-content">
              <div className="animate__animated animate__fadeInLeftBig animate__slow">
                <p className="banner-sub-heading p-2">
                  {t("technology.heroOverline")}
                </p>
                <h1 className="solutions-hero-title">
                  {t("technology.heroTitle1")}
                  <br />
                  {t("technology.heroTitle2")}
                  <br />
                  <span className="gradient-text-span">
                    {t("technology.heroTitleHighlight")}
                  </span>
                </h1>
                <p className="pera-cs solutions-hero-desc">
                  {t("technology.heroDesc")}
                </p>
                <div className="btn-group gap-3">
                  <Link
                    className="btn-cs btn-booking py-3 fw-normal text-decoration-none"
                    to="/solutions"
                  >
                    {t("technology.exploreTech")}{" "}
                    <span className="img-fluid">
                      <img src={img("arrow.svg")} alt="" />
                    </span>
                  </Link>
                  <button
                    className="btn-cs btn-lang d-flex gap-2 py-3 fw-normal"
                    type="button"
                  >
                    {t("common.exploreDemo")}
                    <span className="img-fluid">
                      <img src={img("Border.svg")} alt="" />
                    </span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="succed-sec py-50">
        <div className="container">
          <div className="row align-items-start g-4 g-lg-5">
            <div className="col-lg-4">
              <ScrollReveal from="right" className="platform-media d-flex flex-column gap-4">
                <img
                  className="platform-image w-100"
                  src={img("Integrate.svg")}
                  alt={t("technology.integrateImageAlt")}
                />
                <article className="why-choose-card d-flex gap-3 align-items-start">
                  <span className="platform-check" aria-hidden="true">
                    <img src={img("cost.svg")} alt="" />
                  </span>
                  <div>
                    <h3 className="why-choose-card-title">
                      {t("technology.effortlessTitle")}
                    </h3>
                    <p className="why-choose-card-text">
                      {t("technology.effortlessDesc")}
                    </p>
                  </div>
                </article>
              </ScrollReveal>
            </div>

            <div className="col-lg-8 hero-content h-auto">
              <div className="animate__animated animate__fadeInRighttBig animate__slow platform-content">
                <h2 className="inner-heading mb-0">{t("technology.integrateTitle")}</h2>
                <div className="row g-3 why-choose-cards mt-2">
                  {integrateFeatures.map((item, index) => (
                    <div className="col-12" key={item.title}>
                      <article className="why-choose-card d-flex gap-3 align-items-start">
                        <span className="auto-mate-sale" aria-hidden="true">
                          <img src={img(integrateIcons[index])} alt="" />
                        </span>
                        <div>
                          <h3 className="why-choose-card-title mb-2">
                            {item.title}
                          </h3>
                          <p className="why-choose-card-text">{item.description}</p>
                        </div>
                      </article>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="platform-section py-50">
        <div className="container">
         
          <div className="row g-3 g-xl-4 mt-2 ">
            
              
              <h2 className="heading-cs">{t("technology.poweredTitle")}</h2>
            
            {technologyResults.map((item, index) => (
              <div className="col-6 col-xl-3" key={item.title}>
                <article className="technology-card d-flex flex-column gap-2">
                  <div className="technology-icon">
                    <img src={img(technologyIcons[index])} alt="" aria-hidden="true" />
                  </div>
                  <h3 className="technology-title">{item.title}</h3>
                  <p className="technology-description">{item.description}</p>
                </article>
              </div>
            ))}
          </div>
        </div>
      </section>
      <PlatformPillars />
      <GlobalConnected label={t("globalConnected.label")} />
      <PlatformArchitecture />
      <ReadyToBuild />
    </>
  );
}

export default Technology;
